import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBank = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15.4759 3.14834C15.7973 2.95055 16.2027 2.95055 16.5241 3.14834L29.5241 11.1483C29.9052 11.3828 30.0841 11.8419 29.9622 12.2723C29.8404 12.7028 29.4474 13 29 13H26V21H28C28.5523 21 29 21.4477 29 22C29 22.5523 28.5523 23 28 23H25H19H13H7H4C3.44772 23 3 22.5523 3 22C3 21.4477 3.44772 21 4 21H6V13H3.00002C2.55263 13 2.15967 12.7028 2.03782 12.2723C1.91598 11.8419 2.0949 11.3828 2.47593 11.1483L15.4759 3.14834ZM24 13V21H20V13H24ZM18 13V21H14V13H18ZM12 13V21H8V13H12ZM25 11H25.467L16 5.17418L6.53307 11H7H13H19H25ZM2 25C1.44772 25 1 25.4477 1 26C1 26.5523 1.44772 27 2 27H30C30.5523 27 31 26.5523 31 26C31 25.4477 30.5523 25 30 25H2Z"
	})
});
export default SvgBank;
